<template>
  <v-dialog v-model="dialog" :width="width" :persistent="persistent">
    <template v-slot:activator="{ on }">
      <v-btn
        class="mx-3"
        :icon="icon"
        :color="color"
        v-bind="$attrs"
        v-on="on"
        data-cy="open-dialog-btn"
      >
        <v-icon v-if="buttonIcon !== undefined" :left="!icon">
          {{ buttonIcon }}
        </v-icon>
        <template v-if="!icon">
          {{ buttonText }}
        </template>
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid">
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="i in tabHeaders.length"
          :key="i"
          :value="(i - 1).toString()"
        >
          <slot :name="'tab-item-' + (i - 1).toString()"></slot>
        </v-tab-item>
      </v-tabs-items>
    </v-form>
    <v-spacer style="height: 50px"></v-spacer>

    <v-row class="px-3">
      <v-btn
        class="mr-3"
        color="primary"
        v-if="cancelPath !== undefined"
        @click="cancel()"
        data-cy="btn-cacnel"
        >{{ i18n.t("_Cancel") }}</v-btn
      >
      <v-btn v-if="parseInt(tab) > 0" @click="back()" data-cy="btn-back">{{
        i18n.t("_Back")
      }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="parseInt(tab) === tabHeaders.length - 1"
        color="primary"
        :disabled="!valid"
        @click="$emit('create')"
        data-cy="btn-save"
        >{{ i18n.t("_Save") }}</v-btn
      >
      <v-btn
        v-else
        color="primary"
        @click="forward()"
        :disabled="!valid"
        data-cy="btn-continue"
        >{{ i18n.t("_Continue") }}</v-btn
      >
    </v-row>
  </v-dialog>
</template>

<script>

import i18n from "../helper/i18n"
export default {
  props: {
    tabHeaders: {
      type: Array,
      required: true,
    },
    persistent: {
      default: true,
    },
  },
  data() {
    return {
      valid: false,
      dialog: false,
      tab: undefined,
      i18n:i18n
    };
  },
  methods: {
    forward() {
      var i = parseInt(this.tab);
      if (i < this.tabHeaders.length - 1) {
        this.tab = (i + 1).toString();
      }
    },
    back() {
      var i = parseInt(this.tab);
      if (i > 0) {
        this.tab = (i - 1).toString();
      }
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>

<style></style>
